module.exports = __webpack_public_path__ + "img/salvationarmy.3f7d7a1.png";